export default "__VITE_ASSET__3JT7B7c6__"